import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

type IconScissorProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
}

// This component is needed because Anthony was unable to locate a print icon in the design system
export const IconScissor: React.FC<IconScissorProps> = ({ ...props }) => (
  <MySvgIcon
    width="21px"
    height="21px"
    viewBox="0 0 448 512"
    version="1.1"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z" />
    </g>
  </MySvgIcon>
)
